import * as React from "react"
import type { SVGProps } from "react"
const SvgLightbulb = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 22.29q-.83 0-1.41-.6a2 2 0 0 1-.59-1.4h4q0 .83-.59 1.4a2 2 0 0 1-1.41.6m-3-3a1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7q0-.43.29-.72A1 1 0 0 1 9 17.3h6q.42 0 .71.28.3.3.29.72c-.01.42-.1.52-.29.7a1 1 0 0 1-.71.3zm-.75-3a8 8 0 0 1-2.74-2.75A7.3 7.3 0 0 1 4.5 9.79q0-3.13 2.19-5.32Q8.88 2.3 12 2.3c3.12 0 3.85.73 5.31 2.18A7.2 7.2 0 0 1 19.5 9.8q0 2.03-1.01 3.75a8 8 0 0 1-2.74 2.75zm.6-2h6.3a5.6 5.6 0 0 0 1.74-1.98 5.4 5.4 0 0 0 .61-2.52 5.3 5.3 0 0 0-1.6-3.9q-1.6-1.6-3.9-1.6c-2.3 0-2.83.53-3.9 1.6a5.3 5.3 0 0 0-1.6 3.9q0 1.35.61 2.52a5.6 5.6 0 0 0 1.74 1.98" />
  </svg>
)
export default SvgLightbulb
